/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { SkillSetCard } from '@coursera-web/enterprise-skillset-bank';

const cardStyle = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: (376 / 3) * 4,
  boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 10px 0px',
  transformOrigin: 'top left',
});

function SkillSetCardStack({ lastCardTitle }: { lastCardTitle?: string }) {
  return (
    <div css={css({ width: '473px', position: 'relative', pointerEvents: 'none' })} aria-hidden="true">
      <div
        css={[
          cardStyle,
          css({
            transform: 'scale(0.75) translate(96px, 96px)',
            zIndex: 2,
          }),
        ]}
      >
        <SkillSetCard
          skillSet={{
            academyIds: ['data-science'],
            description:
              'By building robust, fault-tolerant data pipelines that clean and aggregate muddied data into databases, Data Engineers lay the groundwork for data analysts and data scientists to quickly retrieve information for evaluations, experiments, and more, and machine learning engineers to build ML-powered systems.',
            functionId: 'data',
            lure: 'RESKILL',
            occupationId: 'data-engineer',
            targetProficiencies: [
              { skillId: 'database', targetProficiency: 160 },
              {
                skillId: 'probability-and-statistics',
                targetProficiency: 25,
              },
              { skillId: 'data-management', targetProficiency: 160 },
              { skillId: 'visualization-graphic', targetProficiency: 60 },
              { skillId: 'fields-of-mathematics', targetProficiency: 60 },
              {
                skillId: 'statistical-programming',
                targetProficiency: 60,
              },
            ],
            targetSkillProfileName: 'Data Engineer',
            targetSkillProfileType: 'COURSERA_CURATED',
            id: 'reskill_data-engineer_curated',
          }}
        />
      </div>
      <div
        css={[
          cardStyle,
          css({
            transform: 'scale(0.75) translate(48px, 48px)',
            zIndex: 1,
          }),
        ]}
      >
        <SkillSetCard
          skillSet={{
            academyIds: ['data-science'],
            description:
              'The AI-Aware Professional understands the opportunities and challenges of applying Artificial Intelligence in the business. They know how AI technology might be leveraged to help bring new products to market, streamline business decisions, reduce operational costs, and improve customer experience.',
            lure: 'LITERACY',
            functionId: 'software-engineering-information-technology',
            occupationId: 'ai-aware-professional',
            targetProficiencies: [
              { skillId: 'data-management', targetProficiency: 25 },
              { skillId: 'machine-learning', targetProficiency: 25 },
              { skillId: 'statistics', targetProficiency: 25 },
            ],
            targetSkillProfileName: 'AI-Aware Professional',
            targetSkillProfileType: 'COURSERA_CURATED',
            id: 'literacy_machine-learning_curated',
          }}
        />
      </div>
      <div
        css={[
          cardStyle,
          css({
            transform: 'scale(0.75) translate(0px, 0px)',
            zIndex: 0,
          }),
        ]}
      >
        <SkillSetCard
          skillSet={{
            academyIds: ['software-engineering'],
            description:
              'Software engineers work with stakeholders to create computer systems and apps. The demand for software engineers is seemingly endless, and by learning the skills to be one, you are able to develop software projects in virtually every aspect of society, from governments and essential services to apps, tools, and video games. Becoming a software engineer involves learning extensive coding languages.',
            functionId: 'software-engineering-information-technology',
            lure: 'RESKILL',
            occupationId: 'software-developer-engineer',
            targetProficiencies: [
              { skillId: 'security-engineering', targetProficiency: 60 },
              { skillId: 'software-engineering', targetProficiency: 160 },
              { skillId: 'software-testing', targetProficiency: 60 },
              {
                skillId: 'theoretical-computer-science',
                targetProficiency: 160,
              },
              { skillId: 'computer-programming', targetProficiency: 160 },
              {
                skillId: 'mobile-application-development',
                targetProficiency: 25,
              },
            ],
            targetSkillProfileName: lastCardTitle ?? 'Expert Software Engineer',
            targetSkillProfileType: 'COURSERA_CURATED',
            id: 'reskill_software-developer-engineer_curated',
          }}
        />
      </div>
    </div>
  );
}

export default SkillSetCardStack;
